import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FaInstagram, FaLinkedin, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import heroVideo from '../assets/videos/sell-hero.mp4';
import { propertiesForSale } from '../data/properties';

// Remove recentSoldProperties array as we are using propertiesForSale

const sellerTestimonials = [
  {
    name: 'Ahmed Al Mansouri',
    location: 'Dubai Hills Estate',
    testimonial: 'Alpha Ahead sold my villa in just 45 days for 7% above asking price. Their marketing strategy and professional approach exceeded my expectations.',
    rating: 5,
    img: 'https://randomuser.me/api/portraits/men/32.jpg'
  },
  {
    name: 'Sarah Johnson',
    location: 'Dubai Marina',
    testimonial: 'The team handled everything professionally from valuation to closing. I received multiple offers within the first week of listing.',
    rating: 5,
    img: 'https://randomuser.me/api/portraits/women/44.jpg'
  },
  {
    name: 'Mohammed Rahman',
    location: 'The Valley',
    testimonial: 'Excellent service and transparent communication throughout the process. They maximized my property value and made the sale seamless.',
    rating: 5,
    img: 'https://randomuser.me/api/portraits/men/35.jpg'
  }
];

const sellingSteps = [
  {
    step: 1,
    title: 'Free Valuation',
    desc: 'Get an accurate market valuation backed by comprehensive data analysis.',
    icon: '📊'
  },
  {
    step: 2,
    title: 'Marketing Strategy',
    desc: 'Professional photography, virtual tours, and multi-platform marketing.',
    icon: '📸'
  },
  {
    step: 3,
    title: 'Showings & Offers',
    desc: 'Organized viewings and negotiation support for the best offers.',
    icon: '🤝'
  },
  {
    step: 4,
    title: 'Closing Support',
    desc: 'Complete transaction management from offer acceptance to handover.',
    icon: '✅'
  }
];

function SellPage() {
  const [valuationForm, setValuationForm] = useState({
    name: '',
    email: '',
    phone: '',
    propertyType: '',
    location: '',
    bedrooms: '',
    message: ''
  });

  const handleFormChange = (e) => {
    setValuationForm({
      ...valuationForm,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Valuation form submitted:', valuationForm);
  };

  return (
    <div className="flex flex-col min-h-screen font-sans bg-white">
      <Navbar />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
          <video
            className="absolute inset-0 w-full h-full object-cover z-0"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          >
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black/60 z-0" />
          <div className="relative z-10 max-w-4xl mx-auto text-center px-4 py-16">
            <h1 className="text-4xl md:text-6xl font-light text-white mb-6 drop-shadow-lg tracking-tight">
              Maximize Your Property's Value
            </h1>
            <p className="text-xl text-white/90 mb-8 drop-shadow max-w-3xl mx-auto leading-relaxed font-sans">
              Selling your property in Dubai? Our expert team provides accurate market valuations, strategic marketing, and wide exposure across top portals. From listing to closing, we handle everything—professionally and transparently.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/971505606877?text=I would like to list my property with Alpha Ahead" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-lg bg-accent text-white font-medium text-lg hover:bg-accent/90 transition-colors duration-200 font-sans">
                List Your Property
              </a>
              <a href="https://wa.me/971505606877?text=I need expert advice on selling my property" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-lg bg-transparent text-white font-medium text-lg border-2 border-white/40 hover:bg-white hover:text-primary transition-colors duration-200 font-sans">
                Speak to Expert
              </a>
            </div>
          </div>
        </section>



        {/* Featured Properties For Sale */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-12 text-center tracking-tight">
            Featured Properties For Sale
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {propertiesForSale.map((property) => (
              <div key={property.id} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-2xl transition-shadow duration-300">
                <div className="relative h-64">
                  <img
                    src={property.img}
                    alt={property.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {property.price}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{property.title}</h3>
                  <p className="text-gray-600 mb-2">{property.location}</p>

                  <div className="flex justify-between text-gray-500 text-sm mb-4">
                    <span>{property.beds} Beds</span>
                    <span>{property.baths} Baths</span>
                    <span>{property.sqft} sq.ft</span>
                  </div>

                  <a
                    href={`https://wa.me/971505606877?text=I'm interested in ${property.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-[#25D366] text-white py-3 rounded-lg font-medium hover:bg-[#128C7E] transition-colors duration-200 text-center flex items-center justify-center gap-2"
                  >
                    <FaWhatsapp className="w-5 h-5" />
                    Enquire Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Seller Testimonials */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-12 text-center">
            What Our Sellers Say
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sellerTestimonials.map((testimonial, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 border border-gray-200 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center mb-4">
                  <img src={testimonial.img} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4" />
                  <div>
                    <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                    <p className="text-gray-600 text-sm">{testimonial.location}</p>
                  </div>
                </div>
                <p className="text-gray-600 italic">"{testimonial.testimonial}"</p>
                <div className="flex text-yellow-400">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* How Selling Works */}
        <section className="max-w-6xl mx-auto py-20 px-4">
          <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-12 text-center">
            How Selling Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {sellingSteps.map((step) => (
              <div key={step.step} className="bg-white rounded-2xl p-6 border border-gray-200 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">{step.step}</span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 px-4">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
            style={{
              backgroundImage: `url('/Dubai Hills Estate.jpeg')`,
            }}
          />
          <div className="absolute inset-0 bg-black/70 z-0" />
          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-light text-white mb-6">
              Ready to Sell Your Property?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Join hundreds of satisfied sellers who have maximized their property value with Alpha Ahead.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/971505606877?text=I'm ready to sell my property" target="_blank" rel="noopener noreferrer" className="px-8 py-4 rounded-lg bg-accent text-white font-semibold text-lg hover:bg-accent/90 transition-colors duration-200">
                Get Started Today
              </a>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:+971505606877" className="px-8 py-4 rounded-lg bg-transparent text-white font-semibold text-lg border-2 border-white/40 hover:bg-white hover:text-primary transition-colors duration-200">
                  Call Mobile
                </a>
                <a href="tel:+97144323080" className="px-8 py-4 rounded-lg bg-transparent text-white font-semibold text-lg border-2 border-white/40 hover:bg-white hover:text-primary transition-colors duration-200">
                  Call Landline
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default SellPage; 